import React, { PureComponent } from 'react'

export default class PageNotFound extends PureComponent {
  render() {
    return (
      <div>404 not found</div>
    )
  }
}
